import React from 'react';
import { Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const UpgradeToProMessage: React.FC<{ 
  featureName: string; 
  isLimitReached?: boolean;
  targetTier?: 'Pro' | 'Ultra';
}> = ({ featureName, isLimitReached = false, targetTier = 'Pro' }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const handleUpgrade = () => {
    navigate('/home/account?tab=billing');
  };

  return (
    <div className="p-8 text-center bg-gradient-to-br from-red-50 to-amber-50 rounded-3xl border-2 border-amber-200/50 text-amber-900 shadow-xl shadow-amber-500/10">
      <div className="w-16 h-16 bg-white/50 backdrop-blur-sm rounded-full flex items-center justify-center text-amber-500 mx-auto mb-4 border border-white">
        <Zap size={32} />
      </div>
      
      {isLimitReached && (
        <p className="font-black text-[10px] uppercase tracking-[0.3em] text-red-500 mb-2">{t('common.limit_reached')}</p>
      )}
      
      <p className="font-black text-2xl mb-2 tracking-tighter text-[#1a2b3c]">
        {isLimitReached ? t('common.upgrade_to_continue') : `${t('common.unlock')} ${featureName}`}
      </p>
      
      <p className="text-sm text-[#1a2b3c]/60 font-medium leading-relaxed mb-6 px-2">
        {isLimitReached 
          ? t('common.limit_reached_desc', { feature: featureName, tier: targetTier }) 
          : t('common.upgrade_pro_desc', { tier: targetTier })
        }
      </p>

      <button
        className="w-full bg-[#1a2b3c] text-white py-4 px-6 rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-black active:scale-95 transition-all shadow-xl shadow-gray-200"
        onClick={handleUpgrade} 
      >
        {t('common.upgrade_now')}
      </button>
    </div>
  );
};
